<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md12>
        <v-alert
          text
          type="error"
          icon="mdi-cloud-alert"
          :value="ciemException.error != null"
        >
          {{ ciemException.error }}
        </v-alert>
        <v-alert
          text
          outlined
          color="deep-orange"
          icon="mdi-fire"
          :value="ciemException.warning != null"
        >
          {{ ciemException.warning }}
        </v-alert>
        <v-alert
          text
          dense
          color="teal"
          icon="mdi-clock-fast"
          border="left"
          :value="ciemException.success != null"
        >
          {{ ciemException.success }}
        </v-alert>
      </v-flex>
      <v-flex md5>
        <v-layout row mb-4>
          <v-flex md12>
            <v-card class="">
              <v-system-bar color="orange">
                <v-icon>settings_power</v-icon>

                <div>{{ $t('accueil.derniereConnexion') }}</div>

                <v-spacer></v-spacer>
                <div
                  class="text--primary"
                  v-if="detailAccueil.premiereConnexion"
                >
                  {{ $t('accueil.premiereConnexion') }}
                </div>
                <div v-else>
                  {{ formatDate(detailAccueil.derniereConnexion) }}
                </div>
              </v-system-bar>
            </v-card>
          </v-flex>
        </v-layout>
        <div v-if="$auth.hasRole('ROLE_PARTICIPANT')">
          <v-layout row>
            <div style="min-width: 100px" />
          </v-layout>

          <v-layout row mb-4>
            <v-flex md12>
              <v-card class="">
                <v-system-bar dark color="blue">
                  <v-icon>local_hospital</v-icon>

                  <div>{{ $t('accueil.bilanEnCours') }}</div>
                </v-system-bar>

                <v-container v-if="detailAccueil.bilanEnCours == true">
                  <v-row dense>
                    <v-checkbox
                      v-model="detailAccueil.accordDesistement"
                      @click="sendGestionDesistement()"
                      :label="$t('participant.gestionDesistement')"
                      color="primary"
                    />
                  </v-row>
                </v-container>

                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <v-subheader>
                        {{ $t('accueil.typeVisite') }}
                        <v-spacer />{{ $t('accueil.dateEtEtatVisite') }}
                      </v-subheader>
                      <v-divider />
                      <div v-if="detailAccueil.bilanEnCours == false">
                        <v-layout row>
                          <v-flex md12>
                            {{ $t('accueil.pasDeBilan') }}
                          </v-flex>
                        </v-layout>
                      </div>
                      <div v-else>
                        <v-layout row v-if="detailAccueil.visite1" mt-3>
                          <v-chip
                            class="ma-2"
                            outlined
                            color="primary"
                            label
                            style="min-width: 120px; justify-content: center"
                          >
                            {{ $t(detailAccueil.visite1.typeVisite) }}
                          </v-chip>

                          <v-spacer />

                          <v-flex class="text-md-right">
                            <div>
                              {{
                                formatDateVisite(detailAccueil.visite1.dateRDV)
                              }}
                            </div>
                            <div class="heure-previsionnel">
                              {{
                                formatHeurePrevisionnel(
                                  detailAccueil.visite1.heureFinRDV,
                                )
                              }}
                            </div>
                            <div class="text-caption">
                              <v-chip
                                dark
                                :color="detailAccueil.visite1.colorEtatVisite"
                                style="font-size: 12px; height: 25px"
                                >{{ detailAccueil.visite1.etatVisite }}</v-chip
                              >
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-divider v-if="detailAccueil.visite2" />
                        <v-layout row v-if="detailAccueil.visite2" mt-3>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            label
                            outlined
                            style="min-width: 120px; justify-content: center"
                          >
                            {{ $t(detailAccueil.visite2.typeVisite) }}
                          </v-chip>

                          <v-spacer />
                          <v-flex class="text-md-right">
                            <div>
                              {{
                                formatDateVisite(detailAccueil.visite2.dateRDV)
                              }}
                            </div>
                            <div class="heure-previsionnel">
                              {{
                                formatHeurePrevisionnel(
                                  detailAccueil.visite2.heureFinRDV,
                                )
                              }}
                            </div>
                            <div class="text-caption">
                              <v-chip
                                dark
                                :color="detailAccueil.visite2.colorEtatVisite"
                                style="font-size: 12px; height: 25px"
                                >{{ detailAccueil.visite2.etatVisite }}</v-chip
                              >
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-divider v-if="detailAccueil.visite3" />
                        <v-layout row v-if="detailAccueil.visite3" mt-3>
                          <v-chip
                            class="ma-2"
                            outlined
                            color="primary"
                            label
                            style="min-width: 120px; justify-content: center"
                          >
                            {{ $t(detailAccueil.visite3.typeVisite) }}
                          </v-chip>

                          <v-btn
                            @click="openDialogMammo()"
                            color="primary"
                            dark
                          >
                            {{ $t('accueil.dateMammo') }}
                          </v-btn>

                          <v-spacer />
                          <v-flex class="text-md-right">
                            <div>
                              {{
                                formatDateVisite(detailAccueil.visite3.dateRDV)
                              }}
                            </div>
                            <div class="heure-previsionnel">
                              {{
                                formatHeurePrevisionnel(
                                  detailAccueil.visite3.heureFinRDV,
                                )
                              }}
                            </div>
                            <div class="text-caption">
                              <v-chip
                                dark
                                :color="detailAccueil.visite3.colorEtatVisite"
                                style="font-size: 12px; height: 25px"
                                >{{ detailAccueil.visite3.etatVisite }}</v-chip
                              >
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row v-if="detailAccueil.mammo" mt-3>
                          <v-chip
                            class="ma-2"
                            outlined
                            color="primary"
                            label
                            style="min-width: 120px; justify-content: center"
                          >
                            {{ $t(detailAccueil.mammo.typeVisite) }}
                          </v-chip>

                          <v-spacer />
                          <v-flex class="text-md-right">
                            <div>
                              {{
                                formatDateVisite(detailAccueil.mammo.dateRDV)
                              }}
                            </div>
                            <div class="heure-previsionnel">
                              {{
                                formatHeurePrevisionnel(
                                  detailAccueil.mammo.heureFinRDV,
                                )
                              }}
                            </div>
                            <div class="text-caption">
                              <v-chip
                                dark
                                :color="detailAccueil.mammo.colorEtatVisite"
                                style="font-size: 12px; height: 25px"
                                >{{ detailAccueil.mammo.etatVisite }}</v-chip
                              >
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row v-if="detailAccueil.osteo" mt-3>
                          <v-chip
                            class="ma-2"
                            outlined
                            color="primary"
                            label
                            style="min-width: 120px; justify-content: center"
                          >
                            {{ $t(detailAccueil.osteo.typeVisite) }}
                          </v-chip>

                          <v-spacer />
                          <v-flex class="text-md-right">
                            {{ formatDateOsteo(detailAccueil.osteo.dateRDV) }}
                            <div class="text-caption">
                              <v-chip
                                dark
                                :color="detailAccueil.osteo.colorEtatVisite"
                                style="font-size: 12px; height: 25px"
                                >{{ detailAccueil.osteo.etatVisite }}</v-chip
                              >
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-divider />
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="$auth.hasRole('ROLE_CORRESPONDANT')">
          <v-layout row mb-4>
            <v-flex md12>
              <v-card class="">
                <v-system-bar dark color="blue">
                  <v-icon>business</v-icon>

                  <div>
                    {{ $t('accueil.correspondant.administration.titre') }}
                  </div>
                </v-system-bar>

                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <v-layout row>
                        <v-chip class="ma-2" outlined color="primary" label>
                          {{
                            $t(
                              'accueil.correspondant.administration.etablissementRattachement',
                            )
                          }}
                        </v-chip>
                        <v-spacer />
                        <v-flex class="text-md-right">
                          {{
                            detailAccueil.etablissementRattachement
                              ? detailAccueil.etablissementRattachement
                              : $t(
                                  'accueil.correspondant.administration.aucunEtablissementRattachement',
                                )
                          }}
                        </v-flex>
                      </v-layout>
                      <v-divider />
                      <v-layout row>
                        <v-chip class="ma-2" outlined color="primary" label>
                          {{
                            $t(
                              'accueil.correspondant.administration.entrepriseInseeRattachement',
                            )
                          }}
                        </v-chip>
                        <v-spacer />
                        <v-flex class="text-md-right">
                          {{
                            detailAccueil.entrepriseInseeRattachement
                              ? detailAccueil.entrepriseInseeRattachement
                              : $t(
                                  'accueil.correspondant.administration.aucuneEntrepriseInseeRattachement',
                                )
                          }}
                        </v-flex>
                      </v-layout>
                      <v-divider />
                      <v-layout row>
                        <v-chip class="ma-2" outlined color="primary" label>
                          {{
                            $t(
                              'accueil.correspondant.administration.groupementRattachement',
                            )
                          }}
                        </v-chip>
                        <v-spacer />
                        <v-flex class="text-md-right">
                          {{ detailAccueil.groupementRattachement }}
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md12>
              <v-card class="">
                <v-system-bar dark color="blue">
                  <v-icon>directions_run</v-icon>

                  <div>
                    {{ $t('accueil.correspondant.mutationsEnCours.titre') }}
                  </div>
                </v-system-bar>

                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <v-layout row>
                        <v-chip
                          class="ma-2"
                          outlined
                          color="primary"
                          label
                          style="min-width: 120px; justify-content: center"
                        >
                          {{
                            $t(
                              'accueil.correspondant.mutationsEnCours.entrantes',
                            )
                          }}
                        </v-chip>

                        <v-spacer />

                        <v-flex class="text-md-right">
                          {{
                            $t(
                              'accueil.correspondant.mutationsEnCours.nombreEntrantes',
                              [detailAccueil.nbreMutationsEntrantesEnCours],
                            )
                          }}
                        </v-flex>
                      </v-layout>
                      <v-divider />
                      <v-layout row>
                        <v-chip
                          class="ma-2"
                          outlined
                          color="primary"
                          label
                          style="min-width: 120px; justify-content: center"
                        >
                          {{
                            $t(
                              'accueil.correspondant.mutationsEnCours.sortantes',
                            )
                          }}
                        </v-chip>

                        <v-spacer />

                        <v-flex class="text-md-right">
                          {{
                            $t(
                              'accueil.correspondant.mutationsEnCours.nombreSortantes',
                              [detailAccueil.nbreMutationSortantesEnCours],
                            )
                          }}
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>

      <v-spacer />
      <v-flex md6>
        <v-layout row>
          <v-flex md12>
            <template
              v-if="$auth.hasRole('ROLE_PARTICIPANT') && $auth.dmcAccepte()"
            >
              <v-card>
                <v-system-bar dark color="blue">
                  <v-icon>file_present</v-icon>

                  <div>{{ $t('accueil.mesNouveauxDocuments') }}</div>
                </v-system-bar>

                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersDocumentsBilan"
                        :items="detailAccueil.documents"
                        :no-data-text="$t('noDataText')"
                        hide-default-footer
                        show-select
                        show-expand
                        :expanded.sync="expanded"
                        v-model="documentsSelected"
                      >
                        <template #[`header.data-table-select`]>
                          <v-simple-checkbox
                            hide-details
                            v-model="selectAll"
                            :indeterminate="indeterminate"
                          ></v-simple-checkbox>
                        </template>
                        <template #[`expanded-item`]="{ item }">
                          <td
                            class="py-2 px-2"
                            :colspan="headersDocumentsBilan.length + 1"
                          >
                            <v-data-table
                              :headers="headersDocumentsBilanJoint"
                              :items="documentsJoints(item)"
                              elevation="0"
                              show-select
                              hide-default-footer
                              hide-default-header
                              v-model="documentsSelected"
                            >
                              <template #[`item.dateCreation`]="{ item }">
                                <td>
                                  {{ formatLocalDate(item.dateCreation) }}
                                </td>
                              </template>
                              <template #[`item.typeDocument`]="{ item }">
                                {{ item.typeDocument.label }}
                              </template>
                              <template #[`item.nomDocument`]="{ item }">
                                {{
                                  item.modeAffichageNomDocument
                                    ? item.modeAffichageNomDocument ===
                                      'INFO_DOCUMENT'
                                      ? item.libelleDocument
                                      : item.nomDocument
                                    : item.typeDocument
                                          .modeAffichageNomDocument ===
                                        'INFO_DOCUMENT'
                                      ? item.libelleDocument
                                      : item.nomDocument
                                }}
                              </template>
                              <template #[`item.id`]="{ item }">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      v-on:click="
                                        selectedDocumentBilan(item, true)
                                      "
                                      >mdi-eye-circle</v-icon
                                    >
                                  </template>
                                  <span>{{
                                    $t('document.list.eyeHover')
                                  }}</span>
                                </v-tooltip>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      v-on:click="
                                        selectedDocumentBilan(item, false)
                                      "
                                      >mdi-download-circle</v-icon
                                    >
                                  </template>
                                  <span>{{
                                    $t('document.list.downloadHover')
                                  }}</span>
                                </v-tooltip>
                              </template>
                            </v-data-table>
                          </td>
                        </template>
                        <template
                          #[`item.data-table-expand`]="{
                            item,
                            isExpanded,
                            expand,
                          }"
                        >
                          <div
                            v-if="
                              item?.documentJoint?.length ||
                              item?.documentJointLS?.length
                            "
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  @click="expand(!isExpanded)"
                                  v-bind="attrs"
                                  v-on="on"
                                  :class="{
                                    'v-data-table__expand-icon': true,
                                    'v-data-table__expand-icon--active':
                                      isExpanded,
                                  }"
                                >
                                  mdi-chevron-down-circle
                                </v-icon>
                              </template>
                              <span>{{ $t('document.list.expandHover') }}</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template #[`item.dateCreation`]="{ item }">
                          <td>{{ formatLocalDate(item.dateCreation) }}</td>
                        </template>
                        <template #[`item.id`]="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                v-on:click="selectedDocumentBilan(item, true)"
                                >mdi-eye-circle</v-icon
                              >
                            </template>
                            <span>{{ $t('document.list.eyeHover') }}</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                v-on:click="selectedDocumentBilan(item, false)"
                                >mdi-download-circle</v-icon
                              >
                            </template>
                            <span>{{ $t('document.list.downloadHover') }}</span>
                          </v-tooltip>
                        </template>
                        <template #[`item.typeDocument`]="{ item }">
                          {{ item.typeDocument.label }}
                        </template>
                        <template #[`item.nomDocument`]="{ item }">
                          {{
                            item.modeAffichageNomDocument
                              ? item.modeAffichageNomDocument ===
                                'INFO_DOCUMENT'
                                ? item.libelleDocument
                                : item.nomDocument
                              : item.typeDocument.modeAffichageNomDocument ===
                                  'INFO_DOCUMENT'
                                ? item.libelleDocument
                                : item.nomDocument
                          }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        color="primary"
                        @click="dialogSendDocuments = true"
                        :disabled="documentsSelected.length === 0"
                        >{{ $t('button.send') }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
              <v-btn
                v-if="
                  $auth.hasRole('ROLE_PARTICIPANT') &&
                  !this.detailAccueil.refusDMC
                "
                class="mt-2"
                :to="{
                  name: 'document/resultatsAnalyses',
                  params: {
                    namespaceonly: true,
                    categorie: 'MEDICO_TECHNIQUE',
                  },
                }"
                >{{ $t('accueil.plusDocuments') }}</v-btn
              >
            </template>
            <template
              v-if="$auth.hasRole('ROLE_PARTICIPANT') && !$auth.dmcAccepte()"
            >
              <v-card>
                <v-card-text>
                  <span v-html="$t('accueil.activationDMC.activeDmc')" />
                  <v-btn class="mt-10" color="primary" @click="activeDmc()"
                    >{{ $t('accueil.activationDMC.activeDmcBtn') }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </template>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="visualisePDF" scrollable max-width="100%">
      <v-card>
        <v-card-title class="headline pink white--text">
          {{ currentDocument.fileName }}
          <v-spacer></v-spacer>
          <v-btn @click="visualisePDF = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-title>

        <v-card-text style="height: 600em">
          <vue-pdf-app
            :pdf="currentDocument.contentDocument"
            :file-name="currentDocument.fileName"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn @click="visualisePDF = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDateMammo" width="500px">
      <v-card>
        <v-card-title class="headline pink white--text">
          {{ $t('accueil.dateMammo') }}
        </v-card-title>

        <v-card-text class="body-1">
          <br />
          <date-picker
            :label="$t('accueil.dateDerniereMammo')"
            v-model="dateMammo"
            :close-on-content-click="false"
            :first-day-of-week="1"
            :date-formatter="dateFormatter"
            :max="new Date().toISOString().substr(0, 10)"
            :startByYear="true"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="saveDateMammo()"
            :disabled="!dateMammo"
            color="primary"
          >
            {{ $t('button.save') }}
          </v-btn>
          <v-btn @click="dialogDateMammo = false">
            {{ $t('button.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogSendDocuments" width="60vw">
      <v-card>
        <v-card-title class="headline pink white--text">
          {{ $t('document.send.title') }}
        </v-card-title>

        <v-card-text class="body-1">
          <v-form>
            <v-layout row mt-5 mr-0 ml-0>
              <v-flex md6 class="flex-end">
                {{ $t('document.send.dialog.mail') }}
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model="formDocument.mail"
                  :label="$t('document.send.input.mail')"
                  :error-messages="$errors($v.formDocument.mail)"
                  :disabled="formDocument.myselft"
                  autocomplete="off"
                />
              </v-flex>
            </v-layout>
            <v-layout row mt-5 mr-0 ml-0 class="flex-end">
              <v-checkbox
                :label="$t('document.send.input.myself')"
                v-model="formDocument.myselft"
                @change="toggleMail"
              ></v-checkbox>
            </v-layout>
            <v-layout row mt-5 mr-0 ml-0>
              <v-flex md6 class="flex-end">
                {{ $t('document.send.dialog.password') }}
              </v-flex>
              <v-flex md6>
                <v-text-field
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  v-model="formDocument.password"
                  :label="$t('document.send.input.password')"
                  :error-messages="$errors($v.formDocument.password)"
                  autocomplete="new-password"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-label>
            {{ $t('document.send.dialog.data') }}
          </v-label>
          <v-btn
            @click="sendDocuments()"
            color="primary"
            :disabled="$v.formDocument.$invalid"
            :loading="envoiDocs"
          >
            {{ $t('button.send') }}
          </v-btn>
          <v-btn @click="cancelSendDocument()">
            {{ $t('button.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getTemporality } from '@/utils/date'
import moment from 'moment'
import Api from '@/utils/api'
import { getter } from '@/utils/store'
import toasted from '@/utils/toasted'
import auth from '@/utils/oauth'
import VuePdfApp from 'vue-pdf-app'
import DateFormatter from '@/plugins/mixins/DateFormatter'
import _ from 'lodash'
import { alert } from '@/commun/alertMessage'
import { required, email } from 'vuelidate/lib/validators'

const scoped = {
  data: null,
}

export default {
  mixins: [DateFormatter],
  beforeRouteEnter(to, from, next) {
    new Api('get-detail-accueil')
      .get()
      .then((response) => {
        scoped.data = response.body
        next()
      })
      .catch((error) => {
        toasted.error('accueil.error.detail')
        if (error && error.error == 'invalid_token') {
          auth.logout()
        } else {
          next()
        }
      })
  },
  props: {
    msg: String,
  },
  components: {
    VuePdfApp,
  },
  data() {
    return {
      expanded: [],
      derniersElementsOuverts: [],
      documentsSelected: [],
      detailAccueil: {
        documentsCiem: [],
        documents: [],
      },
      headers: [
        {
          value: 'documentName',
          text: this.$t('accueil.documentsCiem.headers.documentName'),
          sortable: false,
        },
        {
          value: 'idDocumentCiem',
          text: this.$t('accueil.documentsCiem.headers.download'),
          sortable: false,
        },
      ],
      headersDocumentsBilanJoint: [
        {
          value: 'typeDocument',
          text: this.$t('accueil.documents.headers.typeDocument'),
          sortable: false,
        },
        {
          value: 'dateCreation',
          text: this.$t('accueil.documents.headers.dateCreation'),
          sortable: false,
        },
        {
          value: 'nomDocument',
          text: this.$t('accueil.documents.headers.libelleDocument'),
          sortable: false,
        },
        {
          value: 'id',
          text: this.$t('accueil.documents.headers.download'),
          sortable: false,
        },
      ],
      visualisePDF: false,
      dialogDateMammo: false,
      dialogSendDocuments: false,
      dateMammo: null,
      ciemException: alert(),
      currentDocument: {
        contentDocument: null,
        fileName: null,
      },
      showPassword: false,
      envoiDocs: false,
      formDocument: {
        mail: null,
        password: null,
        myselft: false,
      },
    }
  },
  mounted() {
    if (scoped.data) {
      this.detailAccueil = scoped.data
    }
    this.$nextTick(function () {
      this.$v.formDocument.$touch()
    })
  },
  beforeDestroy() {
    this.resetAlert()
  },
  computed: {
    headersDocumentsBilan() {
      var headersFull = [...this.headersDocumentsBilanJoint]
      headersFull.push({
        value: 'data-table-expand',
        text: this.$t('accueil.documents.headers.annexes'),
      })
      return headersFull
    },
    selectAll: {
      get() {
        const allSelected =
          this.documentsSelected.length === this.toutDocumentsEtJoints.length
        const noneSelected = this.documentsSelected.length === 0
        return (
          this.documentsSelected.length > 0 && (allSelected || noneSelected)
        )
      },
      set(value) {
        if (value) {
          this.toggleSelectAll(true)
        } else {
          this.toggleSelectAll(false)
        }
      },
    },
    indeterminate() {
      return !this.selectAll && this.documentsSelected?.length > 0
    },
    toutDocumentsEtJoints() {
      let docs = [...this.detailAccueil.documents]
      ;(this.detailAccueil?.documents || []).forEach((doc) => {
        docs = docs.concat(
          this.documentsJoints(doc).filter((doc) => doc.isSelectable),
        )
      })
      return docs
    },
  },
  methods: {
    documentsJoints(doc) {
      const joints = (doc?.documentJoint || []).map((doc) => {
        return { ...doc, isSelectable: true }
      })
      const documentJointLS = (doc?.documentJointLS || []).map((doc) => {
        return { ...doc, isSelectable: false }
      })
      return joints.concat(documentJointLS)
    },
    toggleSelectAll(value) {
      if (value) {
        this.documentsSelected = this.toutDocumentsEtJoints
      } else {
        this.documentsSelected = []
      }
    },
    getTemporality(dateString) {
      return this.$t(...Object.values(getTemporality(dateString)))
    },
    formatDate(value) {
      const date = value ? moment(value).local().format('DD/MM/YYYY HH:mm') : ''
      return date
    },
    formatDateOsteo(value) {
      const date = value ? moment(value).local().format('DD/MM/YYYY') : ''
      return date
    },
    formatDateVisite(value) {
      return `${moment(value).local().format('DD/MM/YYYY')} à ${moment(value)
        .local()
        .format('HH:mm')}`
    },
    formatHeurePrevisionnel(value) {
      return `${this.$t('accueil.dureePrevisionnelle')} ${value.slice(
        0,
        2,
      )}h${value.slice(3, 5)}`
    },
    formatLocalDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
    extractDocument(document) {
      const binaryString = window.atob(document.bytes) // Comment this if not using base64
      const bytes = new Uint8Array(binaryString.length)
      return bytes.map((byte, i) => binaryString.charCodeAt(i))
    },
    selectedDocumentBilan(item, preview) {
      this.$api(
        `document/${item.id}/${item.isSelectable === false ? 'ls/' : ''}`,
      )
        .get()
        .then((response) => {
          if (preview) {
            this.previewPDF(response.body)
          } else {
            this.downloadPDF(response.body)
          }
        })
        .catch((error) => {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.selectdocument')
          }
        })
    },
    previewPDF(document) {
      if (document) {
        const mappedData = this.extractDocument(document)
        this.currentDocument.contentDocument = mappedData.buffer
        this.currentDocument.fileName = document.document.nomDocument
        this.visualisePDF = true
      }
    },
    downloadPDF(doc) {
      if (doc) {
        const mappedData = this.extractDocument(doc)
        var blob = new Blob([mappedData], { type: 'application/pdf' })
        var url = window.URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.href = url
        link.setAttribute('download', doc.document.nomDocument) // Nom du fichier de téléchargement
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }
    },
    toggleMail(event) {
      if (event) {
        this.formDocument.mail = this.detailAccueil.mail
      } else {
        this.formDocument.mail = null
      }
    },
    resetFormDocument() {
      this.formDocument.mail = null
      this.formDocument.myselft = false
      this.formDocument.password = null
    },
    cancelSendDocument() {
      this.dialogSendDocuments = false
      this.resetFormDocument()
    },
    sendDocuments() {
      this.envoiDocs = true
      toasted.info('document.send.enCours')
      const input = {
        mail: this.formDocument.mail,
        password: this.formDocument.password,
        idDocuments: this.documentsSelected.map((doc) => doc.id),
      }
      this.$api('document/download')
        .post(input)
        .then((response) => {
          if (
            response &&
            response.body &&
            response.body.ciemException &&
            !_.isEmpty(response.body.ciemException.messages)
          ) {
            response.body.ciemException.messages.forEach((m) => {
              if (m.level == 'ERROR') {
                this.ciemException.error = this.$t(m.errorCode)
              } else if (m.level == 'WARN') {
                this.ciemException.warning = this.$t(m.errorCode)
              } else if (m.level == 'INFO') {
                this.ciemException.success = this.$t(m.errorCode)
              }
            })
          }
          toasted.success('document.send.success')
        })
        .catch((error) => {
          if (this.$te(error.message)) {
            toasted.error(this.$t(error.message))
          } else {
            toasted.error('document.error.sendDocument')
          }
        })
        .finally(() => {
          this.dialogSendDocuments = false
          this.envoiDocs = false
          this.resetFormDocument()
          this.documentsSelected = []
        })
    },
    resetAlert() {
      this.ciemException.error = null
      this.ciemException.warning = null
      this.ciemException.success = null
    },
    openDialogMammo() {
      this.resetAlert()
      this.dialogDateMammo = true
      this.$api('adherents/dateMammo')
        .get()
        .then((response) => {
          if (response.body) {
            this.dateMammo = response.body
          }
        })
        .catch()
        .finally(() => {
          this.dialogDateMammo = true
        })
    },
    saveDateMammo() {
      this.resetAlert()
      this.$api('adherents/dateMammo')
        .post({ date: this.dateMammo })
        .then((response) => {
          if (response && response.body && !_.isEmpty(response.body.messages)) {
            response.body.messages.forEach((m) => {
              if (m.level == 'ERROR') {
                this.ciemException.error = this.$t(m.errorCode)
              } else if (m.level == 'WARN') {
                this.ciemException.warning = this.$t(m.errorCode)
              } else if (m.level == 'INFO') {
                this.ciemException.success = this.$t(m.errorCode)
              }
            })
          }
        })
        .catch()
        .finally(() => {
          this.dialogDateMammo = false
        })
    },
    sendGestionDesistement() {
      this.resetAlert()
      this.$api('adherents/accordDesistement')
        .post(this.detailAccueil.accordDesistement)
        .then((response) => {
          if (response && response.body && !_.isEmpty(response.body.messages)) {
            response.body.messages.forEach((m) => {
              if (m.level == 'ERROR') {
                this.ciemException.error = this.$t(m.errorCode)
              } else if (m.level == 'WARN') {
                this.ciemException.warning = this.$t(m.errorCode)
              } else if (m.level == 'INFO') {
                this.ciemException.success = this.$t(m.errorCode)
              }
            })
          }
        })
        .catch()
        .finally(() => {
          if (this.ciemException.warning || this.ciemException.error) {
            this.detailAccueil.accordDesistement =
              !this.detailAccueil.accordDesistement
          }
          if (this.ciemException.success) {
            //do something
          }
          this.reloadAccueil()
        })
    },
    activeDmc() {
      this.resetAlert()
      this.$api('re-activate-dmc')
        .post()
        .then((response) => {
          if (response && response.body && !_.isEmpty(response.body.messages)) {
            response.body.messages.forEach((m) => {
              if (m.level == 'ERROR') {
                this.ciemException.error = this.$t(m.errorCode)
              } else if (m.level == 'WARN') {
                this.ciemException.warning = this.$t(m.errorCode)
              } else if (m.level == 'INFO') {
                this.ciemException.success = this.$t(m.errorCode)
              }
            })
          } else {
            toasted.success('auth.reactivate')
            this.reloadPrincipal()
          }
        })
        .catch()
    },
    reloadPrincipal() {
      const extraInfoAuhthentification = {
        roleCorrespondant: false,
      }
      return new Api('principal', 'oauth/')
        .post(extraInfoAuhthentification)
        .then((response) => {
          this.$store.commit('oauth/userRefresh', response.body)
        })
    },
    reloadAccueil() {
      this.$api('get-detail-accueil')
        .get()
        .then((response) => {
          this.detailAccueil = response.body
        })
        .catch(() => {
          toasted.error('accueil.error.detail')
        })
    },
  },
  validations() {
    return {
      formDocument: {
        mail: {
          required,
          email,
        },
        password: {
          required,
        },
      },
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: var(--v-text-base);
}

h6 {
  margin: 40px 0 0;
  display: inline-block;
  position: relative;
}

h6:before {
  content: '';
  position: absolute;
  width: 50px;
  height: 1px;
  bottom: 0;
  left: 0%;
  border-bottom: 4px solid var(--v-primary-base);
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.mt-3 {
  align-items: center;
}

.mt-10 {
  margin-top: 10px;
}

.dateMammo {
  padding-top: 20px;
}

.heure-previsionnel {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.v-dialog .layout {
  align-items: center;
}

.v-dialog .flex {
  padding: 5px;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  text-align: end;
}

.v-label {
  margin-right: 10px;
}
</style>
